<div class="block" style="padding: 20px; margin-top: 20px;">
  <ul>
    <li *ngFor="let user of userService.getUsers()">{{user.name}}</li>
  </ul>
</div>
